import { ProblemsSolvedSummaryCard } from './ProblemsSolvedSummaryCard';
import { ProblemsSolvedCard } from './ProblemsSolvedCard';
import styles from './ProblemsSolvedGrid.module.css';

type ProblemsSolvedGridProps = {
  problemsSolved: {
    heading: string;
    problemText: string;
    solutionText: string;
  }[];
};

const ELEMENTS_PER_ROW = 3;

export const ProblemsSolvedGrid = ({ problemsSolved }: ProblemsSolvedGridProps) => {
  return (
    <div className={styles.problemSolvedGridContainer}>
      {problemsSolved.map(({ heading, problemText, solutionText }, index) => {
        const isFirstInRow = index % ELEMENTS_PER_ROW === 0;
        const isFirstRow = index < ELEMENTS_PER_ROW;
        return (
          <ProblemsSolvedCard
            key={index}
            withVerticalBorder={!isFirstInRow}
            withHorizontalBorder={isFirstRow}
            title={heading}
            problemText={problemText}
            solutionText={solutionText}
          />
        );
      })}
      <ProblemsSolvedSummaryCard />
    </div>
  );
};
